/* screens/sales/plansAccess.js — кто видит раздел «Тарифы» (/console/plans) и его вкладки.

   Прав два, и они независимы: `private_plans_access` (закрытые условия для клиентов,
   subscriptions.manage_private_plans) и `public_plans_access` (публичная линейка,
   subscriptions.manage_public_plans). Комбинированного флага нет намеренно (контракт):
   плитка, гард маршрута и вкладки читают одни и те же функции отсюда — иначе одно
   из мест рано или поздно забудет второе право, и человек с одним доступом упрётся
   в редирект или в чужую вкладку с 403. */

const TABS = [
  { value: 'private', label: 'Закрытые', flag: 'private_plans_access' },
  { value: 'public', label: 'Публичные', flag: 'public_plans_access' },
];

export function hasPlansAccess(user) {
  return !!(user && (user.private_plans_access || user.public_plans_access));
}

// Решение гарда маршрута /console/plans: куда увести, или null — пустить. Гард в
// routes.jsx только рисует Navigate по этому ответу — так решение проверяется без
// роутера, а исходник гарда сторожевым тестом обязан звать именно эту функцию.
export function plansRouteRedirect(user) {
  if (!user) return '/signin';
  return hasPlansAccess(user) ? null : '/console';
}

// Вкладки — только по своему праву, порядок фиксированный: закрытые первыми
// (раздел исторически их, ссылки без ?tab= вели туда).
export function plansTabsFor(user) {
  if (!user) return [];
  return TABS.filter((t) => !!user[t.flag]).map(({ value, label }) => ({ value, label }));
}

// Вкладка из адреса: ссылку ?tab=public мог прислать коллега с другим набором
// прав — тогда открываем первую СВОЮ, а не пустой экран.
export function resolvePlansTab(requested, tabs) {
  const list = Array.isArray(tabs) ? tabs : [];
  if (requested && list.some((t) => t.value === requested)) return requested;
  return list.length ? list[0].value : null;
}

// Описание плитки — о том, что человеку реально доступно: обещать «публичную
// линейку» тому, кому откроется только вкладка закрытых, значит врать с порога.
export function plansTileDesc(user) {
  const priv = !!(user && user.private_plans_access);
  const pub = !!(user && user.public_plans_access);
  if (priv && pub) {
    return 'Закрытые условия для сетевых клиентов и публичная линейка: сроки, цены, лимиты, акции и окна продаж.';
  }
  if (pub) {
    // Ровно то, что делает сервер: закрепляет прежнюю цену за автопродлениями.
    // «Подписчики защищены» обещало бы больше — лимиты и фичи меняются у всех сразу.
    return 'Публичная линейка: сроки, цены, лимиты, акции и окна продаж. При смене цены действующие подписчики продлеваются по прежней цене.';
  }
  return 'Закрытые условия для сетевых клиентов: цена, запросы, лимиты. В общей витрине не показываются.';
}

// Смена вкладки сбрасывает открытый тариф: ?plan= у каждой вкладки свой, и слаг
// закрытого тарифа во вкладке публичных ничего бы не открыл (и наоборот).
export function switchPlansTab(prev, value) {
  const sp = new URLSearchParams(prev);
  sp.set('tab', value);
  sp.delete('plan');
  return sp;
}
